import grupoDeRotasHttpService from '../_services/grupoDeRotasHttpService'
import { GET_ALL_GRUPOS_DE_ROTAS, GET_SPECIFIC_GRUPO_DE_ROTAS } from './mutation-types'

export default {
  listarGruposDeRotas: async ({ commit }) => {
    try {
      const response = await grupoDeRotasHttpService.getGruposDeRotas()
      commit(GET_ALL_GRUPOS_DE_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGrupoDeRotasEspecifico: async ({commit}, id) => {
    try {
      const response = await grupoDeRotasHttpService.getSpecificGrupoDeRotas(id)
      commit(GET_SPECIFIC_GRUPO_DE_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  }
}